export default __webpack_public_path__ + "2e062a1d92116a64a8ba097f978b55a2.webp";